// @ts-nocheck
import { Component } from 'react';
import { ApplyPluginsType } from 'umi';
import dva from 'dva';
// @ts-ignore
import createLoading from '/codebuild/output/src3512736026/src/app/node_modules/dva-loading/dist/index.esm.js';
import { plugin, history } from '../core/umiExports';
import ModelConnection0 from '/codebuild/output/src3512736026/src/app/src/models/connection.ts';
import ModelCredentials1 from '/codebuild/output/src3512736026/src/app/src/models/credentials.ts';
import ModelDashboard2 from '/codebuild/output/src3512736026/src/app/src/models/dashboard.ts';
import ModelDataObjects3 from '/codebuild/output/src3512736026/src/app/src/models/dataObjects.ts';
import ModelDataset4 from '/codebuild/output/src3512736026/src/app/src/models/dataset.ts';
import ModelDatasetTest5 from '/codebuild/output/src3512736026/src/app/src/models/datasetTest.ts';
import ModelDownload6 from '/codebuild/output/src3512736026/src/app/src/models/download.ts';
import ModelEvents7 from '/codebuild/output/src3512736026/src/app/src/models/events.ts';
import ModelFlows8 from '/codebuild/output/src3512736026/src/app/src/models/flows.ts';
import ModelFolders9 from '/codebuild/output/src3512736026/src/app/src/models/folders.ts';
import ModelGenerativeDashboard10 from '/codebuild/output/src3512736026/src/app/src/models/generativeDashboard.ts';
import ModelGlobal11 from '/codebuild/output/src3512736026/src/app/src/models/global.js';
import ModelHub12 from '/codebuild/output/src3512736026/src/app/src/models/hub.ts';
import ModelInsight13 from '/codebuild/output/src3512736026/src/app/src/models/insight.ts';
import ModelInsightMemory14 from '/codebuild/output/src3512736026/src/app/src/models/insightMemory.ts';
import ModelIntegration15 from '/codebuild/output/src3512736026/src/app/src/models/integration.js';
import ModelLayout16 from '/codebuild/output/src3512736026/src/app/src/models/layout.ts';
import ModelLogin17 from '/codebuild/output/src3512736026/src/app/src/models/login.ts';
import ModelNotifications18 from '/codebuild/output/src3512736026/src/app/src/models/notifications.ts';
import ModelOrganization19 from '/codebuild/output/src3512736026/src/app/src/models/organization.ts';
import ModelOrganizationAiContext20 from '/codebuild/output/src3512736026/src/app/src/models/organizationAIContext.ts';
import ModelOverlay21 from '/codebuild/output/src3512736026/src/app/src/models/overlay.ts';
import ModelSetting22 from '/codebuild/output/src3512736026/src/app/src/models/setting.js';
import ModelSources23 from '/codebuild/output/src3512736026/src/app/src/models/sources.ts';
import ModelSpotlight24 from '/codebuild/output/src3512736026/src/app/src/models/spotlight.ts';
import ModelUser25 from '/codebuild/output/src3512736026/src/app/src/models/user.js';
import ModelUser226 from '/codebuild/output/src3512736026/src/app/src/models/user2.ts';
import ModelVisualization27 from '/codebuild/output/src3512736026/src/app/src/models/visualization.ts';
import ModelWorkspace28 from '/codebuild/output/src3512736026/src/app/src/models/workspace.ts';

let app:any = null;

export function _onCreate(options = {}) {
  const runtimeDva = plugin.applyPlugins({
    key: 'dva',
    type: ApplyPluginsType.modify,
    initialValue: {},
  });
  app = dva({
    history,
    
    ...(runtimeDva.config || {}),
    // @ts-ignore
    ...(typeof window !== 'undefined' && window.g_useSSR ? { initialState: window.g_initialProps } : {}),
    ...(options || {}),
  });
  
  app.use(createLoading());
  (runtimeDva.plugins || []).forEach((plugin:any) => {
    app.use(plugin);
  });
  app.model({ namespace: 'connection', ...ModelConnection0 });
app.model({ namespace: 'credentials', ...ModelCredentials1 });
app.model({ namespace: 'dashboard', ...ModelDashboard2 });
app.model({ namespace: 'dataObjects', ...ModelDataObjects3 });
app.model({ namespace: 'dataset', ...ModelDataset4 });
app.model({ namespace: 'datasetTest', ...ModelDatasetTest5 });
app.model({ namespace: 'download', ...ModelDownload6 });
app.model({ namespace: 'events', ...ModelEvents7 });
app.model({ namespace: 'flows', ...ModelFlows8 });
app.model({ namespace: 'folders', ...ModelFolders9 });
app.model({ namespace: 'generativeDashboard', ...ModelGenerativeDashboard10 });
app.model({ namespace: 'global', ...ModelGlobal11 });
app.model({ namespace: 'hub', ...ModelHub12 });
app.model({ namespace: 'insight', ...ModelInsight13 });
app.model({ namespace: 'insightMemory', ...ModelInsightMemory14 });
app.model({ namespace: 'integration', ...ModelIntegration15 });
app.model({ namespace: 'layout', ...ModelLayout16 });
app.model({ namespace: 'login', ...ModelLogin17 });
app.model({ namespace: 'notifications', ...ModelNotifications18 });
app.model({ namespace: 'organization', ...ModelOrganization19 });
app.model({ namespace: 'organizationAIContext', ...ModelOrganizationAiContext20 });
app.model({ namespace: 'overlay', ...ModelOverlay21 });
app.model({ namespace: 'setting', ...ModelSetting22 });
app.model({ namespace: 'sources', ...ModelSources23 });
app.model({ namespace: 'spotlight', ...ModelSpotlight24 });
app.model({ namespace: 'user', ...ModelUser25 });
app.model({ namespace: 'user2', ...ModelUser226 });
app.model({ namespace: 'visualization', ...ModelVisualization27 });
app.model({ namespace: 'workspace', ...ModelWorkspace28 });
  return app;
}

export function getApp() {
  return app;
}

export class _DvaContainer extends Component {
  constructor(props: any) {
    super(props);
    // run only in client, avoid override server _onCreate()
    if (typeof window !== 'undefined') {
      _onCreate();
    }
  }

  componentWillUnmount() {
    let app = getApp();
    app._models.forEach((model:any) => {
      app.unmodel(model.namespace);
    });
    app._models = [];
    try {
      // 释放 app，for gc
      // immer 场景 app 是 read-only 的，这里 try catch 一下
      app = null;
    } catch(e) {
      console.error(e);
    }
  }

  render() {
    const app = getApp();
    app.router(() => this.props.children);
    return app.start()();
  }
}
